import { render, staticRenderFns } from "./NoticePageRead.vue?vue&type=template&id=19f67097&scoped=true&"
import script from "./NoticePageRead.vue?vue&type=script&lang=ts&"
export * from "./NoticePageRead.vue?vue&type=script&lang=ts&"
import style0 from "./NoticePageRead.vue?vue&type=style&index=0&id=19f67097&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f67097",
  null
  
)

export default component.exports